// extracted by mini-css-extract-plugin
export default {"nav":"others_nav__7AgcY","active":"others_active__SBs+4","indicator":"others_indicator__HpH8L","profiles":"others_profiles__AUJoT","chatPlaceholder":"others_chatPlaceholder__rq9E-"};